<template>
  <div
    class="p-4"
    style="background-color: #DEDEDE50"
  >
    <table
      class="w-full h-full relative p-4"
    >
      <thead>
        <tr class="p-4">
          <th
            class=" p-4"
            v-for="item in tableHeadersForEditMode()"
            :key="item.key"
          >
            {{ item.title }}
          </th>
        </tr>
      </thead>
      <draggable
        v-model="tableData"
        tag="tbody"
        ghost-class="ghost"
        :animation="300"
        :force-fallback="true"
        :fallback-on-body="true"
        handle=".drag-handle"
        item-key="id"
        :move="onDragMove"
        @end="onDragEnd"
        @start="onDragStart"
      >
        <template v-for="(td, tdIndex) in tableData">
          <template v-if="td">
            <tr
              v-for="(detail, detailIndex) in td.details"
              :key="`${td.id}_${detail.id}`"
              :class="`tr-values vs-table--tr p-4 ${detailIndex === td.details.length - 1 && 'border-b-4'} select-none`"
              style="border-color: #DEDEDE50"
            >
              <template v-if="isEditMode">
                <td
                  v-if="detailIndex === 0"

                  :rowspan="td.details.length > 1 && !isStartDragging ? td.details.length : null"
                  class="td p-2 bg-white"
                >
                  <vs-icon
                    v-show="tdIndex !== 0"
                    color="#493493"
                    class="self-center cursor-move drag-handle"
                    icon="menu"
                  />
                </td>
                <td
                  v-if="detailIndex === 0 "
                  :rowspan="td.details.length > 1 && !isStartDragging ? td.details.length : null"
                  class="td p-2 bg-white"
                  @click="tdIndex !== 0 && onDelete(td)"
                >
                  <img
                    v-if="tdIndex !== 0"
                    :src="require('@/assets/shipo-icon-delete.svg')"
                    class="bg-primary rounded-lg cursor-pointer w-[20px] h-[20px]"
                    alt="delete"
                  >
                </td>
                <template v-if="td.calculate_type.toLowerCase() === 'storage'">
                  <td class="td p-2 bg-white">
                    <select-with-search
                      :options="storageOptions"
                      v-model="td.name"
                      placeholder="Select Storage"
                      @input="() => onStorageNameChange(td, tdIndex)"
                    />
                  </td>
                  <td class="td p-2 bg-white">
                    <select-with-search
                      :options="populateOptionsByType('tug', detail.tug)"
                      v-model="detail.tug"
                      :placeholder="`Select Tug Name`"
                      @input="val => onChange(detail, val, 'tug')"
                    />
                  </td>
                  <td class="td p-2 bg-white">
                    <select-with-search
                      :options="populateOptionsByType('barge', detail.barge)"
                      v-model="detail.barge"
                      :placeholder="`Select Barge Name`"
                      @input="val => onChange(detail, val, 'barge')"
                    />
                  </td>
                  <td class="td p-2 bg-white">
                    <v-autonumeric
                      placeholder="Enter Quantity"
                      :disabled="true"
                      v-model="detail.quantity"
                      :options="globalNumericOptions"
                      class="vs-input--input autonumeric-primary"
                      @input="val => onChange(detail, val, 'quantity')"
                    />
                  </td>
                </template>
                <template v-else-if="td.calculate_type.toLowerCase() === 'step'">
                  <td
                    v-if="detailIndex === 0"
                    :rowspan="td.details.length > 1 && !isStartDragging ? td.details.length : null"
                    class="td p-2 bg-white"
                  >
                    {{ td.name }}
                  </td>
                  <template v-if="detailIndex === 0">
                    <td class="td p-2 bg-white">
                      <select-with-search
                        :options="populateOptionsByType('tug', detail.tug)"
                        v-model="detail.tug"
                        :placeholder="`Select Tug Name`"
                        @input="val => onChange(detail, val, 'tug')"
                      />
                    </td>
                    <td class="td p-2 bg-white">
                      <select-with-search
                        :options="populateOptionsByType('barge', detail.barge)"
                        v-model="detail.barge"
                        :placeholder="`Select Barge Name`"
                        @input="val => onChange(detail, val, 'barge')"
                      />
                    </td>
                  </template>
                  <template v-if="!isStartDragging">
                    <template v-if="detailIndex !== 0">
                      <td class="td p-2 bg-white rounded-none">
                        {{ detail.storage_name }}
                      </td>
                      <td class="td p-2 bg-white" />
                    </template>
                    <td
                      :class="`p-2 bg-white ${detailIndex === 0 && 'rounded-tr-lg rounded-br-none'} ${detailIndex === td.details.length - 1 && 'rounded-tr-none rounded-br-lg'}`"
                    >
                      <v-autonumeric
                        :disabled="detailIndex === 0"
                        placeholder="Enter Quantity"
                        v-model="detail.quantity"
                        :options="globalNumericOptions"
                        class="vs-input--input autonumeric-primary"
                        @input="val => onChange(detail, val, 'quantity')"
                      />
                      <div
                        style="color: #B01E47"
                      >
                        {{ quantityValidation(detail.storage_name, detail.quantity, td.id) }}
                      </div>
                    </td>
                  </template>
                </template>
              </template>
              <!--  RENDER DETAIL TBS STORAGE  -->
              <template
                v-else
                v-for="(th, thIndex) in tableHeadersForEditMode().filter(item => isEditMode? item.key !== 'name' && item.key !== 'drag' && item.key !== 'action' : item)"
              >
                <template v-if="td.calculate_type.toLowerCase() === 'storage'">
                  <td
                    :key="thIndex"
                    :class="{
                      'p-2 bg-white': true,
                      'rounded-l-lg': detailIndex === 0 && thIndex === 0,
                      'rounded-tr-lg': detailIndex === 0 && thIndex === tableHeadersForEditMode().length - 1,
                      'rounded-br-lg': detailIndex === td.details.length - 1 && thIndex === tableHeadersForEditMode().length - 1
                    }"
                  >
                    {{ td[th.key] || detail[th.key] }}
                  </td>
                </template>
                <template v-else-if="td.calculate_type.toLowerCase() === 'step'">
                  <td
                    v-if="detailIndex === 0 && th.key === 'name'"
                    :rowspan="td.details.length > 1 ? td.details.length : null"
                    :key="thIndex"
                    class="p-2 bg-white rounded-tl-lg rounded-bl-lg"
                  >
                    {{ td.name }}
                  </td>
                  <template v-if="detail.is_storage && th.key !== 'name'">
                    <td
                      v-if="th.key === 'trip_number'"
                      :key="thIndex"
                      class="td p-2 bg-white rounded-none"
                    >
                      {{ detail.storage_name }}
                    </td>
                    <td
                      v-else
                      :key="thIndex"
                      :class="{
                        'p-2 bg-white': true,
                        'rounded-l-lg': detailIndex === 0 && thIndex === 0,
                        'rounded-tr-lg': detailIndex === 0 && thIndex === tableHeadersForEditMode().length - 1,
                        'rounded-br-lg': detailIndex === td.details.length - 1 && thIndex === tableHeadersForEditMode().length - 1
                      }"
                    >
                      {{ detail[th.key] }}
                    </td>
                  </template>
                  <template v-else>
                    <td
                      v-if=" th.key !== 'name'"
                      :key="thIndex"
                      :class="{
                        'p-2 bg-white': true,
                        'rounded-l-lg': detailIndex === 0 && thIndex === 0,
                        'rounded-tr-lg': detailIndex === 0 && thIndex === tableHeadersForEditMode().length - 1,
                        'rounded-br-lg': detailIndex === td.details.length - 1 && thIndex === tableHeadersForEditMode().length - 1
                      }"
                    >
                      {{ td[th.key] || detail[th.key] }}
                    </td>
                  </template>
                </template>
              </template>
            </tr>
          </template>
        </template>
      </draggable>
    </table>
    <div
      class="ml-auto flex w-full flex-col gap-2 mt-4"
    >
      <div
        class="ml-auto text-[13px] font-semibold flex gap-16 w-full p-2 justify-end rounded-lg"
        :style="isEditMode ? '':`background-color: #C2B6EA`"
      >
        Total Direct Vessel: {{ ' ' }}
        <div>{{ totalDirectVessel }}</div>
      </div>
      <div
        class="ml-auto text-[13px] font-semibold flex gap-16 w-full p-2 justify-end rounded-lg"
        :style="isEditMode ? '':`background-color: #C2B6EA`"
      >
        Total Cargo Supply:  {{ ' ' }}
        <div>{{ totalCargoSupply }}</div>
      </div>
    </div>
    <vs-button
      v-if="isEditMode"
      class="rounded-lg flex flex-row justify-center w-full py-1 focus:outline-none mt-4"
      color="secondary"
      @click="onAddStorage"
    >
      <div class="flex justify-center items-center gap-2">
        <vs-icon
          icon="add"
          color="secondary"
          size="small"
          class="p-2 bg-white flex justify-center items-center rounded-lg"
        />
        <span>Add Storage</span>
      </div>
    </vs-button>
    <vs-button
      v-if="isEditMode"
      class="rounded-lg flex flex-row justify-center w-full py-1 focus:outline-none mt-2"
      color="secondary"
      @click="onAddStep"
    >
      <div class="flex justify-center items-center gap-2">
        <vs-icon
          icon="add"
          color="secondary"
          size="small"
          class="p-2 bg-white flex justify-center items-center rounded-lg"
        />
        <span>Add Step</span>
      </div>
    </vs-button>
  </div>
</template>
<script lang="ts">
import { flatten, isEmpty, sum } from 'lodash'
import draggable from 'vuedraggable'

import SelectWithSearch from '@/components/selectWithSearch/index.vue'

export default {
  components: {
    SelectWithSearch,
    draggable
  },
  data(){
    return {
      isStartDragging: false,
      tugOptions: [],
      bargeOptions: [],
      quantityErrors: {},
      totalDirectVessel: 0,
      totalCargoSupply: 0,
      draggableContent: {},
      storageOptions: [
        {text:'STORAGE 1', value:'STORAGE 1'},
        {text:'STORAGE 2', value:'STORAGE 2'},
        {text:'STORAGE 3', value:'STORAGE 3'}
      ],
      isLoading: false,
      tableData: [],
      tableHeaders: [
        { key: 'name', title: 'No' },
        { key: 'trip_number', title: 'Trip number' },
        { key: 'tug', title: 'Tug Name' },
        { key: 'barge', title: 'Barge Name' },
        { key: 'quantity', title: 'quantity' }
      ]
    }
  },
  watch:{
    tbsDataList:{
      immediate:true,
      deep: true,
      handler(val) {
        if(val.length) {
          const finalData = [...val.filter(t => t.blending_type === 'STORAGE')]
          this.tableData = finalData.map(item => (
            {
              ... item,
              total_quantity: item.calculate_type === 'STORAGE' ? item.details[0].loading_plan_detail.barge_line_up.act_loaded : item.total_quantity,
              details: item.details.map(detail => ({
                ...detail,
                ...(detail.loading_plan_detail && {
                  tug: detail.loading_plan_detail.barge_line_up.tug,
                  barge: detail.loading_plan_detail.barge_line_up.barge,
                  trip_number: detail.loading_plan_detail.barge_line_up.trip_number
                })
              }))
            }
          ))
          this.totalDirectVessel = sum(flatten(this.tableData.filter(item=> item && item.calculate_type === 'STEP').map(item => item.details.filter(detail => !detail.is_storage))).map(item => item.quantity))
          this.totalCargoSupply = sum([...flatten(this.tableData.filter(item => item && item.calculate_type === 'STORAGE').map(item => item.details.filter(detail => !detail.is_storage))).map(item => item.quantity), this.totalDirectVessel])
        }
      }
    },
    loadingPlanList:{
      immediate:true,
      deep: true,
      handler(val) {
        this.tugOptions = val.map(p => ({ text: p.blu_data.tug, value: p.blu_data.tug }))
        this.bargeOptions = val.map(p => ({ text: p.blu_data.barge, value: p.blu_data.barge }))
      }
    },
    isEditMode: {
      immediate: true,
      handler(val) {
        if(val && !this.tbsDataList.length){
          this.onAddStorage()
        } else if(!val && !this.tbsDataList.length) {
          this.tableData = []
        }
      }
    },
    tableData:{
      deep: true,
      immediate: true,
      handler(value) {
        const val = [...value]
        const stepCargoLeft = {}
        val.filter(item => item).forEach((item) => {
          item.details.forEach(detail => {
            if(item.calculate_type === 'STEP' && !detail.is_storage) {
              if(stepCargoLeft.hasOwnProperty(detail.tug)){
                stepCargoLeft[detail.tug] = stepCargoLeft[detail.tug] + detail.quantity
              } else {
                stepCargoLeft[detail.tug] = detail.quantity
              }
            }
          })
        })
        this.errorValidation()
        this.totalDirectVessel = sum(flatten(val.filter(item => item && item.calculate_type === 'STEP').map(item => item.details.filter(detail => !detail.is_storage))).map(item => item.quantity))
        this.totalCargoSupply = sum([...flatten(val.filter(item => item.calculate_type === 'STORAGE').map(item => item.details.filter(detail => !detail.is_storage))).map(item => item.quantity), this.totalDirectVessel])
        const payload = val.filter(item => item).map((item, itemIndex) => ({
          tbs_header_id: this.tbsHeaderId,
          blending_type: 'STORAGE',
          calculate_type: item.calculate_type,
          name: item.name,
          total_quantity: sum(item.details.map(detail => detail.quantity)) ,
          display_order: itemIndex + 1,
          tbs_data_detail: item.details.map(detail => ({
            loading_plan_detail_id: this.loadingPlanList.find(lp => lp.blu_data.tug === detail.tug) ? this.loadingPlanList.find(lp => lp.blu_data.tug === detail.tug).id : null,
            is_storage: detail.is_storage,
            storage_id: null,
            storage_name: detail.storage_name ? detail.storage_name : null,
            quantity: detail.quantity
          }))
        }))
        this.setPayloadStorage(payload.filter(item => item.name))
      }
    }
  },
  methods: {
    calculatedStorages(array) {
      const usedStorage = {}
      const storages = {}
      array.filter(item => item).forEach((item => {
        if(item.calculate_type === 'STEP') {
          item.details.forEach(detail => {
            if(detail.is_storage) {
              if(usedStorage.hasOwnProperty(detail.storage_name)) {
                usedStorage[detail.storage_name] = usedStorage[detail.storage_name]  + detail.quantity
              }else{
                usedStorage[detail.storage_name] = detail.quantity
              }
            }
          })
        }
      }))
      array.filter(item=> item && item.calculate_type === 'STORAGE').forEach(item => {
        if(storages.hasOwnProperty(item.name)) {
          storages[item.name] = storages[item.name] + item.details[0].quantity;
        } else {
          storages[item.name] = item.details[0].quantity
        }
      })
      return {usedStorage, storages}
    },
    errorValidation() {
      const { usedStorage, storages } = this.calculatedStorages(this.tableData)
      const errors = []
      Object.keys(storages).forEach(key => {
        if(storages[key] > usedStorage[key]) {
          errors.push(`${key} still has <b>${Number(storages[key] - usedStorage[key]).toFixed(2)}</b>. Ton`)
        }
      })
      this.setErrorList(errors)
    },
    quantityValidation(name, value, rawId) {
      const selectedIndex = this.tableData.findIndex(item => item.id === rawId)
      const beforeData = this.tableData.slice(0, selectedIndex)
      const { usedStorage, storages } = this.calculatedStorages(beforeData)
      const finalStorage = !isEmpty(usedStorage) ? usedStorage[name] : 0
      const storageLeft = storages[name]  - finalStorage
      if(Number(storageLeft.toFixed(2)) < Number(value.toFixed(2))) {
        const { usedStorage, storages } = this.calculatedStorages(this.tableData)
        const errors = []
        Object.keys(storages).forEach(key => {
          if(Number(storages[key].toFixed(2)) < Number(usedStorage[key].toFixed(2))) {
            errors.push(`${key} Cannot Exceed <b>${storages[key].toFixed(2)}</b>. Ton`)
          }
        })
        this.setErrorList(errors)
        return `Cannot exceed ${storageLeft < 0 ? 0 : new Intl.NumberFormat('en-US').format(Number(storageLeft.toFixed(2))) }`
      }
    },
    populateOptionsByType(type, oldValue) {
      const selectedDetails = flatten(this.tableData.filter(item => item).map(item => item.details))
      if(type === 'tug') {
        return this.tugOptions.filter(tg => tg.value === oldValue || !selectedDetails.map(item => item.tug).includes(tg.text))
      } else {
        return this.bargeOptions.filter(bg => bg.value === oldValue || !selectedDetails.map(item => item.barge).includes(bg.text))
      }
    },
    getRowToItemIndexMap(table) {
      const map = []
      table.forEach((group, gIndex) => {
        group.details.forEach((row, rIndex) => {
          map.push({
            groupIndex: gIndex,
            rowIndex: rIndex,
            item: row
          })
        })
      })
      return map
    },
    onStorageNameChange(data, index) {
      const selectedSteps = this.tableData.slice(index, this.tableData.length).filter(item => item && item.calculate_type === 'STEP' )
      if(!isEmpty(selectedSteps)) {
        selectedSteps.forEach(st=> st.details.forEach(detail => {
          if(detail.is_storage && detail.storage_id === data.id){
            detail.storage_name = data.name
          }
        }))
      }
    },
    onChange(data, value, type) {
      let selectedLoadingPlan = null
      switch (type){
        case 'tug':
          selectedLoadingPlan =this.loadingPlanList.find(item=>item.blu_data.tug === value).blu_data
          data.barge = selectedLoadingPlan.barge
          data.quantity = selectedLoadingPlan.actual_tonnage
          break;
        case 'barge':
          selectedLoadingPlan =this.loadingPlanList.find(item=>item.blu_data.barge === value).blu_data
          data.tug = selectedLoadingPlan.tug
          data.quantity = selectedLoadingPlan.actual_tonnage
          break;
        default:
          break
      }
    },
    onDragStart() {
      this.isStartDragging = true
    },
    onDragMove(evt){
      const { draggedContext, relatedContext } = evt
      this.draggableContent = { oldList: relatedContext.list, oldElement: draggedContext.element }
      return draggedContext.index !== 0 &&  relatedContext.element && relatedContext.element.display_order !== 1;
    },
    onRepopulateTableData() {
      let stepCounter = 1
      this.tableData = this.tableData.filter(item => item).map((td, tdIndex) => {
        if(td.calculate_type.toLowerCase() === 'step') {
          const storages = []
          this.tableData.filter(item => item).slice(0, tdIndex).filter(item => item.calculate_type.toLowerCase() === 'storage').forEach(storage => {
            if(!isEmpty(storages) && storages.map(item => item.storage_name).includes(storage.name)){
              const selectedStorage = storages.find(st => st.storage_name === storage.name)
              selectedStorage.quantity = selectedStorage.quantity + storage.quantity
            } else {
              storages.push({
                is_storage: true,
                id: td.details[td.details.length - 1].id + 2,
                storage_name: storage.name,
                storage_id: storage.id,
                quantity: storage.quantity
              })
            }
          })
          const rawDetails = td.details
          return {
            ...td,
            name: `STEP ${stepCounter++}`,
            details: td.details.filter(item => !item.is_storage).concat(storages).map((item, detailIndex) => (
              {...item, id: detailIndex, quantity: rawDetails[detailIndex] ? rawDetails[detailIndex].quantity : 0}
            ))
          }
        }
        return td
      })
    },
    onDragEnd(evt) {
      const { newIndex, oldIndex } = evt
      this.tableData = this.tableData.filter(Boolean)

      let map = this.getRowToItemIndexMap(this.tableData)
      const shouldReset =
        (!this.tableData[newIndex] && this.tableData[oldIndex]) ||
        (this.tableData[newIndex] && this.tableData[oldIndex])

      if (shouldReset) {
        this.tableData = this.draggableContent.oldList
        map = this.getRowToItemIndexMap(this.tableData)
      }

      const movedItem = this.tableData.splice(map[oldIndex].groupIndex, 1)[0]
      this.tableData.splice(map[newIndex].groupIndex, 0, movedItem)
      this.onRepopulateTableData()
      this.isStartDragging = false
    },
    onDelete(row) {
      this.tableData = this.tableData.filter(item => item.id !== row.id)
      this.onRepopulateTableData()
    },
    onAddStep(){
      const errors = []
      this.tableData.forEach(item => {
        if(!item.name){
          errors.push(item)
        }
        item.details.forEach(detail => {
          if(detail.is_storage && !detail.storage_name ) {
            errors.push(detail)
          } else if(!detail.is_storage && (!detail.tug || !detail.barge)){
            errors.push(detail)
          }
        })
      })
      if(errors.length) {
        this.showFailedNotification(this, 'Please fill in the empty row before creating another row.')
        return
      }
      const dataStep = this.tableData.filter(item => item.calculate_type.toLowerCase() === 'step')
      const dataStorage = this.tableData.filter(item => item.calculate_type.toLowerCase() === 'storage')
      const lastStep = dataStep[dataStep.length - 1]
      const lastData = this.tableData[this.tableData.length - 1];
      const freshStep = {
        id: lastData ? lastData.id + 1 : 1,
        "blending_type": "STORAGE",
        "calculate_type": "STEP",
        name: `STEP ${ lastStep ?  parseInt(lastStep.name.split(' ')[1]) + 1 : 1 }`,
        details: [
          {
            id: 1,
            is_storage: false,
            quantity: 0,
            storage_name: null,
            storage_id: null
          }
        ]
      }
      dataStorage.forEach(item => {
        const selectedDetail = freshStep.details.find(fd => fd.storage_name && fd.storage_name === item.name)
        if(!selectedDetail) {
          freshStep.details.push(
            {
              is_storage: true,
              id: freshStep.details[freshStep.details.length-1].id+1,
              storage_name: item.name,
              storage_id: item.id,
              quantity: 0
            }
          )
        }
      })
      this.tableData.push(freshStep)
    },
    onAddStorage() {
      const errors = []
      if(this.tableData.length) {
        this.tableData.forEach(item => {
          if(!item.name){
            errors.push(item)
          }
          item.details.forEach(detail => {
            if(detail.is_storage && !detail.storage_name ) {
              errors.push(detail)
            } else if(!detail.is_storage && (!detail.tug || !detail.barge)){
              errors.push(detail)
            }
          })
        })
        if(errors.length) {
          this.showFailedNotification(this, 'Please fill in the empty row before creating another row.')
          return
        }
      }
      const lastData = this.tableData[this.tableData.length - 1];
      const freshStorage = {
        "id": lastData ? lastData.id + 1 : 1,
        "blending_type": "STORAGE",
        "calculate_type": "STORAGE",
        "name": "",
        "total_quantity": 0,
        "display_order": lastData? lastData.display_order + 1 : 1,
        "details": [
          {
            "id": 1,
            "is_storage": false,
            "quantity": 0,
            tug: '',
            barge:''
          }
        ]
      }
      this.tableData.push(freshStorage);
    },
    tableHeadersForEditMode() {
      if(this.isEditMode){
        return [{key: 'drag', title: ''},{key: 'action', title: 'Action'}, {key: 'name', title: 'Step'}, ...this.tableHeaders.filter(th=>th.key !== 'name' && th.key !== 'trip_number')]
      }
      return this.tableHeaders
    }
  },
  props: {
    tbsHeaderId: {
      type: Number,
      default: () => null
    },
    tbsDataList: {
      type: Array,
      default: ()=> []
    },
    loadingPlanList: {
      type: Array,
      default: ()=> []
    },
    isEditMode: {
      type: Boolean,
      default: ()=> false
    },
    setErrorList: {
      type: Function,
      default: () => {}
    },
    setPayloadStorage: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style>
.td {
  &:first-child {
    @apply pl-10;
    @apply rounded-l-2xl;
  }

  &:last-child {
    @apply pr-10;
    @apply rounded-r-2xl;
  }
}
</style>
